import { HttpContextToken } from '@angular/common/http';

export enum ImpersonationAuditActionType {
  CREATE = 0,
  UPDATE = 1,
  DELETE = 2
}

export interface ImpersonationActionLogRequest {
  userId: number;
  modifiedByUserId: number;
  entity: unknown;
  actionType: ImpersonationAuditActionType;
  apiPath: string;
}

export interface ImpersonationRequestMetadata {
  method: string;
  url: string;
  body: unknown;
}

export const IMPERSONATION_REQUEST_METADATA = new HttpContextToken<ImpersonationRequestMetadata | null>(() => null);
